import { message } from 'antd';
import axios from 'axios';
import { client } from '../actions';
import { authHeader, authHeaderForm } from './auth-header';
import showErrorMessage from './showErrorMessage';
import qs from 'qs';

export const createCancelTokenSource = () => {
  const CancelToken = axios.CancelToken;
  return CancelToken.source();
};

const request = {
  get: async (
    url,
    params,
    errorText,
    dataPlaceholder,
    changedBackendErrorText,
    arrayFormat = 'repeat',
    axiosConfig = {},
    hideErrMsg = false
  ) => {
    try {
      const response = await client.get(url, {
        headers: authHeader(),
        params,
        paramsSerializer:
          arrayFormat === false
            ? undefined
            : (params) => qs.stringify(params, { arrayFormat }),
        ...axiosConfig,
      });
      return checkBackendErrorText(
        response,
        changedBackendErrorText,
        dataPlaceholder,
        hideErrMsg
      );
    } catch (error) {
      if (axios.isCancel(error)) return;
      console.error(error);
      !hideErrMsg && showErrorMessage(error, errorText);
      return dataPlaceholder;
    }
  },
  post: async (
    url,
    body,
    errorText,
    dataPlaceholder,
    changedBackendErrorText,
    params = {},
    hideErrMsg = false
  ) => {
    try {
      const response = await client.post(url, body, {
        headers: authHeader(),
        params,
      });
      return checkBackendErrorText(
        response,
        changedBackendErrorText,
        dataPlaceholder,
        hideErrMsg
      );
    } catch (error) {
      console.error(error);
      !hideErrMsg && showErrorMessage(error, errorText);
      return dataPlaceholder;
    }
  },
  delete: async (
    url,
    params,
    errorText,
    dataPlaceholder,
    changedBackendErrorText
  ) => {
    try {
      const response = await client.delete(url, {
        headers: authHeader(),
        params,
      });
      return checkBackendErrorText(
        response,
        changedBackendErrorText,
        dataPlaceholder
      );
    } catch (error) {
      console.error(error);
      showErrorMessage(error, errorText);
      return dataPlaceholder;
    }
  },
  put: async (
    url,
    body,
    errorText,
    dataPlaceholder,
    changedBackendErrorText,
    params,
    extraConfig = {},
    hideErrMsg = false
  ) => {
    try {
      const response = await client.put(url, body, {
        headers: body instanceof FormData ? authHeaderForm() : authHeader(),
        params,
        ...extraConfig,
      });
      return checkBackendErrorText(
        response,
        changedBackendErrorText,
        dataPlaceholder,
        hideErrMsg
      );
    } catch (error) {
      console.error(error);
      !hideErrMsg && showErrorMessage(error, errorText);
      return dataPlaceholder;
    }
  },
};

function checkBackendErrorText(
  response,
  changedBackendErrorText,
  dataPlaceholder,
  hideErrMsg = false
) {
  if (response.data?.result && response.data.result === 'Error') {
    !hideErrMsg && message.error(changedBackendErrorText || response.data.message);
    return dataPlaceholder;
  }
  return response.data;
}

export default request;
